export default __webpack_public_path__ + "static/media/EventLandingPage.875a4181.jpeg";